import api from './api';

export const getBuildings = (params) => api.get('/v1/buildings', { params });
export const getBuilding = (id) => api.get(`/v1/buildings/${id}`);
export const createBuilding = (data) => api.post('/v1/buildings', data);
export const updateBuilding = (id, data) => api.put(`/v1/buildings/${id}`, data);
export const deleteBuilding = (id) => api.delete(`/v1/buildings/${id}`);
export const batchDeleteBuildings = (ids) => api.post('/v1/buildings/batch-delete', { ids });
